import React, { useEffect } from 'react';
import Clients from '../components/Clients';
import Footer from '../components/Footer';
import Hero from '../components/Hero';
import Vision from '../components/Vision';
import Product from '../components/Product';
import Benefits from '../components/Benefits';


const Home = () => {
    useEffect(() => {
        window.scrollTo({top: 0, left: 0, behavior: 'smooth' });
    }, []);

    return (
        <>
            <Hero />
            <Vision />
            <Product />
            <Clients />
            <Benefits />
            <Footer />
        </>

    )
}

export default Home;

